import { useMemo } from "react";
import { useTimezone } from "src/business-components/input/TimeZoneSelector/TimeZoneSelector.hooks";
import { useQueryAppInfo } from "src/queries/info/info.query";
import type { UserTzContext } from "../TimeWindow.calendarPresets";

export const useUserTzContext = (): UserTzContext => {
  const { tz } = useTimezone();
  const timeQuery = useQueryAppInfo();

  const serverTime = timeQuery.data?.time?.now;
  const fetchedAt = useMemo(
    () => (timeQuery.dataUpdatedAt > 0 ? timeQuery.dataUpdatedAt : Date.now()),
    [timeQuery.dataUpdatedAt]
  );

  return useMemo(
    () => ({
      serverTime,
      tz,
      fetchedAt,
    }),
    [serverTime, tz, fetchedAt]
  );
};
